module.exports={name:"Sistema de Gestão Econômica "};